import BasePropertyView from 'BasePropertyView.js';
import Template from 'workflow/properties/main/stage.ejs';
import eventBus from 'EventBus.js';
import constants from 'Constants.js';
import listService  from 'ListService.js';
import util         from 'util/Util.js';

class MainStageWorkflowView extends BasePropertyView {

    initialize( opts ) {
 
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=checkbox]'   : 'updateCheckAttributes',
            'change input[type=text]'       : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

   updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));
        this.model.set( propName, propVal );
        eventBus.trigger(constants.EV_ROLE_OR_STAGE_UPDATED);
    }

    updateCheckAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;

        if (propName === 'isDefault') {
            const stages = listService.getWorkflowStages(false, false);
            stages.map( (v, k) => {
                if (util.isTrue( v.model.get('isDefault') )) {
                    v.model.set('isDefault', 'false');
                }
            });

            const newId = propVal ? this.model.get('id') : 'null';
            listService.workflowProperties.set('defaultStageId', newId ,{silent:true});
            listService.workflowProperties._root.entries[2][1]=newId;
        }

        this.model.set( propName, propVal );
    }


    render() {
        
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        if (this.model.has('isDefault')) {
            const isDefault = util.isTrue(this.model.get('isDefault'));
            $('input[name="isDefault"]').prop('checked', isDefault);
        }

        if (this.model.has('isClosed')) {
            const isClosed = util.isTrue(this.model.get('isClosed'));
            $('input[name="isClosed"]').prop('checked', isClosed);
        }

        this.delegateEvents();
        return this;
    }

}

export default MainStageWorkflowView;
